define('home/views/NotificationCardCreateView',[
    'home/models/Session',
    'home/views/common/ActivityCardView',
    'home/mixins/withReason',
    'home/mixins/asNotificationCard',
    'home/mixins/withTruncate',

    'home/templates/notificationCardCreate',
], function (
    Session,
    ActivityCardView,
    withReason,
    asNotificationCard,
    withTruncate,

    notificationCardCreateTemplate
) {
    'use strict';

    var parent = ActivityCardView;

    var NotificationCardCreateView = parent.extend({
        className: 'card-notif-create card-notif-invite card-notif-note',

        template: notificationCardCreateTemplate,

        templateHelpers: function () {
            return {
                threadDescription: this.model.thread.getPlainDescription(),
                image: this.model.thread.getImage(),
                numTitleLines: 3,
            };
        },

        events: {
            'click [data-action=delete]': 'deleteThread',
            'click [data-action=restore]': 'restoreThread',
        },

        initialize: function () {
            this.session = Session.get();

            this.listenTo(this.model.thread, 'change:content', this.render);
            this.listenTo(this.model.thread, 'change:isDeleted', this.render);
        },

        deleteThread: function () {
            this.model.thread.confirmDelete(true);
        },

        restoreThread: function () {
            this.model.thread.restore();
        },
    });


    var proto = NotificationCardCreateView.prototype;
    withReason.call(proto);
    asNotificationCard.call(proto);
    withTruncate.call(proto);

    return NotificationCardCreateView;
});

